// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__Xitn_","additionalInfo":"AgreementModal_additionalInfo__1ZFsI"};